/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type StorefrontHead_user = {
    readonly serviceId: string | null;
    readonly " $fragmentRefs": FragmentRefs<"StorefrontSocial_user">;
    readonly " $refType": "StorefrontHead_user";
};
export type StorefrontHead_user$data = StorefrontHead_user;
export type StorefrontHead_user$key = {
    readonly " $data"?: StorefrontHead_user$data;
    readonly " $fragmentRefs": FragmentRefs<"StorefrontHead_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorefrontHead_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StorefrontSocial_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = 'be37b972407a12aa7fb1298dc9b08296';
export default node;
